import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import CollageTileDefaultLayout from '@/shared/content/blocks/collage-layouts/CollageTileDefaultLayout.vue';
import { computed, onMounted, onUnmounted, Ref } from 'vue';
import { CollageTileLayout, CollageTileLayoutData } from '@/shared/content/blocks/collage-layouts/collage-layout.store';
import useProductDetailData from '@/shared/product/details/useProductDetailData';
import useOutletProductDetailData from '@/shared/product/details/ui/outlet/useOutletProductDetailData';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductEnvironmentMediaTile',
  props: {
    content: null
  },
  setup(__props: any) {

const props = __props as { content: CollageTileLayout }

const { setEnvironmentImages } = useProductDetailData();
const { setEnvironmentImages: setEnvironmentImagesOutlet } = useOutletProductDetailData();



const tileData: Ref<CollageTileLayout | undefined> = computed(() => {
    const contentData = { ...props.content };

    if (contentData?.tiles) {
        contentData.tiles = contentData.tiles.map(tile => ({ model: { media: tile } }));
        return contentData;
    }

    return undefined;
});

const setEnvironmentImagesForAllProductDetailPages = () => {
    const tiles = tileData.value?.tiles;
    if (tiles) {
        setEnvironmentImagesOutlet(tiles);
        setEnvironmentImages(tiles);
    }
};

const clearEnvironmentImagesForAllProductDetailPages = () => {
    const emptyTiles = [] as CollageTileLayoutData[];
    setEnvironmentImagesOutlet(emptyTiles);
    setEnvironmentImages(emptyTiles);
};

onMounted(setEnvironmentImagesForAllProductDetailPages);
onUnmounted(clearEnvironmentImagesForAllProductDetailPages);


return (_ctx: any,_cache: any) => {
  return (_unref(tileData))
    ? (_openBlock(), _createBlock(CollageTileDefaultLayout, {
        key: 0,
        content: _unref(tileData),
        "is-reversed-layout": false
      }, null, 8, ["content"]))
    : _createCommentVNode("", true)
}
}

})